<template>
  <!-- Fleet Type -->
  <b-tab class="border-0">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('setting.list.managementAsset.gps.change') }}</span>
    </template>

    <!-- Table -->
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :hasCheckbox="false"
      :searchable="true"
      :hasBilingual="true"
    >
      <template #cell(time)="data">
        {{ data.item ? momentDateShortMonth(data.item.time) : '-' }}<br />
        <span class="text-muted" v-if="data.item.time">{{
          data.item ? momentTimeSeconds(data.item.time) : '-'
        }}</span>
      </template>
      <template #cell(oldData)="data">
        <span
          v-if="
            data.item.oldData &&
            (data.item.object.includes('Installed Date') ||
              data.item.object.includes('Tanggal Dipasang') ||
              data.item.object.includes('Tanggal Mulai Sub') ||
              data.item.object.includes('Tanggal Berakhir Sub') ||
              data.item.object.includes('Start Date of Sub') ||
              data.item.object.includes('End Date of Sub'))
          "
        >
          {{ momentDateShortMonth(data.item.oldData) }}<br />
          <span
            v-if="
              data.item.object.includes('Installed Date') ||
              data.item.object.includes('Tanggal Dipasang')
            "
            class="text-muted"
            >{{ momentTimeSeconds(data.item.oldData) }}</span
          >
        </span>
        <span v-else> {{ data.item.oldData ? data.item.oldData : '-' }}<br /> </span>
      </template>
      <template #cell(newData)="data">
        <span
          v-if="
            data.item.object &&
            (data.item.object.includes('Installed Date') ||
              data.item.object.includes('Tanggal Dipasang') ||
              data.item.object.includes('Tanggal Mulai Sub') ||
              data.item.object.includes('Tanggal Berakhir Sub') ||
              data.item.object.includes('Start Date of Sub') ||
              data.item.object.includes('End Date of Sub'))
          "
        >
          {{ momentDateShortMonth(data.item.newData) }}<br />
          <span
            v-if="
              data.item.object.includes('Installed Date') ||
              data.item.object.includes('Tanggal Dipasang')
            "
            class="text-muted"
            >{{ momentTimeSeconds(data.item.newData) }}</span
          >
        </span>
        <span v-else> {{ data.item.newData ? data.item.newData : '-' }}<br /> </span>
      </template>
    </McGrapqlTable>
  </b-tab>
</template>

<script>
import { Helper } from '@/mixin/helper'
import McGrapqlTable from '@/components/McGrapqlTable'

import { GET_CHANGE_HISTORY } from '@/services/api/setting/personalization/gps'

export default {
  components: {
    McGrapqlTable,
  },
  mixins: [Helper],
  props: {
    item: {
      required: true,
    },
  },
  data() {
    return {
      data: [],
      imei: this.$route.params.imei,
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'time',
          label: this.$t('setting.list.managementAsset.gps.changeDate'),
          isSortable: true,
          isLocked: false,
        },
        {
          key: 'user',
          label: this.$t('setting.list.managementAsset.gps.changeBy'),
          isSortable: false,
          isLocked: false,
        },
        {
          key: 'actionType',
          label: this.$t('setting.list.managementAsset.gps.action'),
          isSortable: false,
          isLocked: false,
        },
        {
          key: 'object',
          label: this.$t('setting.list.managementAsset.gps.object'),
          isSortable: false,
          isLocked: false,
        },
        {
          key: 'oldData',
          label: this.$t('setting.list.managementAsset.gps.oldData'),
          isSortable: false,
          isLocked: false,
        },
        {
          key: 'newData',
          label: this.$t('setting.list.managementAsset.gps.newData'),
          isSortable: false,
          isLocked: false,
        },
      ]
    },
    query() {
      return {
        get: async (filter) => {
          const language = localStorage.getItem('language') === 'en' ? 'English' : 'Indonesia'
          if (filter.search) {
            filter.search = filter.search.toLowerCase()
          }

          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_CHANGE_HISTORY,
            variables: {
              filter: { ...filter, imei: this.imei, language: language },
            },
          })
          const self = this
          const result = res.data.deviceAuditLogs.deviceAuditLogs
          self.data = result.data
          return result
        },
      }
    },
  },
}
</script>
